export default __webpack_public_path__ + "static/media/a.574f3d59.svg";